import $ from 'jquery';
import React, {MouseEvent} from 'react';
import {observer} from 'mobx-react';
import {Store} from '../../stores/store';
import {FilterRule} from '../../stores/GeneralSelectorTableStore';
import onClickOutside from 'react-onclickoutside';
import {px} from 'csx';
import {I18n} from '../../i18n/i18n';
import MinMaxFilterMenu from './MinMaxFilterMenu';
import AdvancedSortingMenu from './AdvancedSortingMenu';

interface ColumnHeaderFilterMenuProps {
    store: Store;
}

interface ColumnHeaderFilterMenuState {
    filterRules: FilterRule[];
}

@observer
class ColumnHeaderFilterMenu extends React.Component<ColumnHeaderFilterMenuProps, ColumnHeaderFilterMenuState> {
    // Handler for react-onclickoutside
    public handleClickOutside = (e: MouseEvent<HTMLElement>): void => {
        this.props.store.selectorTableStore.triggerTableHeaderFilterMenu();
    };

    public componentDidMount(): void {
        $(window).resize(this.closeDropdownOnWindowResize);
    }

    public closeDropdownOnWindowResize = (): void => {
        this.props.store.selectorTableStore.triggerTableHeaderFilterMenu();
    };

    public componentWillUnmount(): void {
        $(window).off('resize', this.closeDropdownOnWindowResize);
    }

    public onMenuSinkClick = (e: React.MouseEvent): void => {
        e.preventDefault();
        e.stopPropagation();
    };

    public reduceXValueIfToNearAtBorder(xValue: number): number {
        let changedXValue = xValue;
        const windowWidth = $(window).width();
        if (windowWidth !== undefined && windowWidth - 200 < changedXValue) {
            changedXValue = windowWidth - 200;
        }
        return changedXValue;
    }

    public getNameFromAttribute(): string {
        const {selectorTableStore} = this.props.store;
        return selectorTableStore.tableColumns()[selectorTableStore.tableHeaderFilterMenu.attribute].label;
    }

    public renderMinMaxIrregularitySortOptionsForPrimaryAttributes(): React.ReactNode | null {
        const {selectorTableStore, skipSlopes} = this.props.store;
        const columnDef = selectorTableStore.tableColumns()[selectorTableStore.tableHeaderFilterMenu.attribute];

        if (columnDef.scoreAttributes && !skipSlopes) {
            return <AdvancedSortingMenu selectorTableStore={selectorTableStore} />;
        }
        return null;
    }

    private isRate(): boolean {
        const {tableHeaderFilterMenu, tableColumns} = this.props.store.selectorTableStore;
        const column = tableColumns()[tableHeaderFilterMenu.attribute];

        return (column && column.isRate) || false;
    }

    public render() {
        const {selectorTableStore, compareStore} = this.props.store;
        if (selectorTableStore.tableHeaderFilterMenu.isClosed) {
            return null;
        }

        const attributeTitle = this.getNameFromAttribute();
        return (
            <div
                className="dropdown-menu"
                onClick={this.onMenuSinkClick}
                style={{
                    position: 'absolute',
                    top: selectorTableStore.tableHeaderFilterMenu.y,
                    left: this.reduceXValueIfToNearAtBorder(selectorTableStore.tableHeaderFilterMenu.x),
                    display: 'block',
                    borderRadius: 2,
                    padding: 5,
                }}>
                <svg role="presentation" focusable="false" className="DateInput_fang DateInput_fang_1" style={{top: 15, left: 10}}>
                    <path className="DateInput_fangShape DateInput_fangShape_1" d="M0,10 20,10 10,0z" />
                    <path className="DateInput_fangStroke DateInput_fangStroke_1" d="M0,10 10,0 20,10" />
                </svg>
                <div
                    style={{
                        fontSize: px(10),
                        fontWeight: 'bold',
                        marginBottom: 2,
                    }}>
                    <I18n i18nKey="table:columnHeaderFilterMenuTitle">{{attributeTitle}} Filter</I18n>
                </div>
                <MinMaxFilterMenu
                    channelCompareIsEnabled={compareStore.compareIsEnabled}
                    tableHeaderFilterMenu={selectorTableStore.tableHeaderFilterMenu}
                    activeTableFilters={selectorTableStore.activeTableFilters}
                    applyFilterRules={selectorTableStore.applyFilterRules}
                    triggerTableHeaderFilterMenu={selectorTableStore.triggerTableHeaderFilterMenu}
                    isRate={this.isRate()}
                />
                {compareStore.compareIsEnabled ? null : this.renderMinMaxIrregularitySortOptionsForPrimaryAttributes()}
            </div>
        );
    }
}

export default onClickOutside(ColumnHeaderFilterMenu);



// WEBPACK FOOTER //
// ./src/views/Table/ColumnHeaderFilterMenu.tsx